module.exports = __webpack_public_path__ + "img/10.9250f10c.jpg";